export const NFT_DISASSEMBLE_LOG_LIST_REQUEST = 'NFT_DISASSEMBLE_LOG_LIST_SUCCESS';
